import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/abstract-map.jpeg'


const _withScopeId = n => (_pushScopeId("data-v-4ae687bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "flex google-maps-background-left" }
const _hoisted_3 = { class: "google-maps-route-directions__route-icon" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "row-start-1 col-start-1"
}, null, -1))
const _hoisted_5 = { class: "google-maps-route-directions__route google-maps-background-left" }
const _hoisted_6 = {
  key: 0,
  class: "grow pr-3 google-maps-background-right"
}
const _hoisted_7 = { class: "flex flex-col text-xs leading-normal items-end h-full justify-center" }
const _hoisted_8 = { class: "flex gap-1 items-center" }
const _hoisted_9 = { class: "flex gap-1 items-center" }

import { Loader } from '@googlemaps/js-api-loader'
    import { computed, onMounted, ref, toRefs, watch } from 'vue'
    import IconClock from '@/components/icons/IconClock.vue'
    import IconRuler from '@/components/icons/IconRuler.vue'
    import IconDirections from '@/components/icons/IconDirections.vue'
    import { useI18n } from 'vue-i18n'

    interface Props {
        origin: string
        destination: string
        travelMode?: TravelMode|null
    }

    enum TravelMode {
        BICYCLING = 'BICYCLING',
        DRIVING = 'DRIVING',
        TRANSIT = 'TRANSIT',
        WALKING = 'WALKING',
    }

    
export default /*#__PURE__*/_defineComponent({
  props: {
    origin: null,
    destination: null,
    travelMode: { default: null }
  },
  setup(__props: any) {

const props = __props as { origin: string, destination: string, travelMode: TravelMode|null }

    const { t } = useI18n()

    

    const { origin, destination, travelMode } = toRefs(props)
    const loader = new Loader({
        apiKey: 'AIzaSyACIjqaQKMV_NdVKNjE21csDsHEQl86cH4',
        version: 'weekly',
        libraries: ['places'],
    })

    const directions = ref<object|null>(null)

    onMounted(async() => {
        const google = await loader.load()
        const directionsService = new google.maps.DirectionsService()

        const updateDirections = async(): Promise<void> => {
            if (!origin?.value || !destination?.value) {
                return
            }

            directions.value = await directionsService.route({
                origin: origin.value,
                destination: destination.value,
                travelMode: travelMode.value ?? TravelMode.DRIVING,
            })
        }

        updateDirections()
        watch(origin, updateDirections)
        watch(destination, updateDirections)
        watch(travelMode, updateDirections)
    })

    const link = computed(() => {
        const params = new URLSearchParams()

        params.append('api', '1')
        params.append('origin', origin.value)
        params.append('destination', destination.value)
        params.append('travelmode', travelMode.value?.toLowerCase() ?? 'driving')

        return 'https://google.com/maps/dir/?' + params.toString()
    })

    const duration = computed(() => {
        const seconds = directions.value?.routes[0]?.legs[0]?.duration.value

        let text = ''

        if (seconds >= 3600) {
            const hours = Math.floor(seconds / 60 / 60)
            const remainingMinutes = Math.round(seconds / 60 - hours * 60)
            text = hours.toString() + '.' + remainingMinutes.toString() + ' ' + t('viewing.route.hours').toString()
        } else {
            text = Math.round(seconds / 60).toString() + ' mins'
        }

        return text
    })

    const distance = computed(() => {
        return directions.value?.routes[0]?.legs[0]?.distance.text
    })

    const hasRoute = computed(() => {
        return directions.value !== null
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    href: _unref(link),
    target: "_blank",
    class: "google-maps-route-directions"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(IconDirections, {
          size: 30,
          class: "row-start-1 col-start-1 text-orange-500"
        })
      ]),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('viewing.route.toProperty')), 1)
    ]),
    (_unref(hasRoute))
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(IconRuler, { size: 12 }),
              _createTextVNode(" " + _toDisplayString(_unref(distance)), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(IconClock, { size: 12 }),
              _createTextVNode(" " + _toDisplayString(_unref(duration)), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})